import React from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import IncidentCreateModal from "Projects/CC_cubi_clan_project/GlobalComponents/IncidentCreateModal/IncidentCreateModal";

// Defaults matching the previously hardcoded values
const DEFAULTS = {
  company_name: "MUGIN",
  company_tagline:
    "Este es un proyecto ficticio que sirve como ejemplo de una página web corporativa para MUGIN. Próximamente se incluirá contenido real sobre la empresa y sus productos.",
  address: "I.E.S. Miguel de Mañara, Calle Cultura, s/n, La Rinconada",
  email: "MUGINsanjose@gmail.com",
  social_facebook: "https://www.facebook.com/profile.php?id=100057086515415",
  social_instagram: "https://www.instagram.com/MUGINsj",
  social_youtube: "https://www.youtube.com/@teatroMUGIN",
  social_tiktok: "",
  phone: "",
  whatsapp: "",
  show_email: "true",
  show_social_facebook: "true",
  show_social_instagram: "true",
  show_social_youtube: "true",
  show_social_tiktok: "true",
  show_phone: "true",
  show_whatsapp: "true",
};

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: { ...DEFAULTS },
      incidentOpen: false,
    };
    this.handleOpenIncident = () => this.setState({ incidentOpen: true });
    this.handleCloseIncident = () => this.setState({ incidentOpen: false });
  }

  componentDidMount() {
    this.loadConfig();
  }

  async loadConfig() {
    try {
      const response = await doFetch("MUGIN", "getSiteContentByPrefix?prefix=FOOTER_", {
        method: "GET",
      });
      if (!response || !response.ok) return;

      const contentType = response.headers?.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        throw new Error(`Respuesta no JSON en footer (${response.status})`);
      }

      const data = await response.json();
      const items = data && data.DATA ? data.DATA : [];
      const config = { ...DEFAULTS };
      items.forEach((item) => {
        if (item.contentKey && item.configValue !== null) {
          const key = item.contentKey.replace("FOOTER_", "");
          config[key] = item.configValue;
        }
      });
      this.setState({ config });
    } catch (error) {
      console.error("Error al cargar el footer:", error);
    }
  }

  render() {
    const { config, incidentOpen } = this.state;
    const { showIncidentBtn = false, appCode = "MUGIN" } = this.props;

    const socialLinks = [
      { key: "social_facebook", icon: "facebook-f" },
      { key: "social_instagram", icon: "instagram" },
      { key: "social_youtube", icon: "youtube" },
      { key: "social_tiktok", icon: "tiktok" },
    ].filter((s) => config[s.key] && config[`show_${s.key}`] !== "false");

    return (
      <MDBFooter
        bgColor="light"
        className="text-center text-lg-start text-muted mt-5"
      >
        <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
          <div className="me-5 d-none d-lg-block">
            <span>Síguenos en nuestras redes sociales:</span>
          </div>
          <div>
            {socialLinks.map((s) => (
              <a
                key={s.key}
                href={config[s.key]}
                target="_blank"
                rel="noreferrer"
                className="me-4 text-reset"
              >
                <MDBIcon fab icon={s.icon} />
              </a>
            ))}
          </div>
        </section>
        <section>
          <MDBContainer className="text-center text-md-start mt-5">
            <MDBRow className="mt-3">
              <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">
                  <MDBIcon icon="gem" className="me-3" />
                  {config.company_name}
                </h6>
                <p>{config.company_tagline}</p>
              </MDBCol>
              <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contacto</h6>
                {config.address && (
                  <p>
                    <MDBIcon icon="home" className="me-3" />
                    {config.address}
                  </p>
                )}
                {config.email && config.show_email !== "false" && (
                  <p>
                    <MDBIcon icon="envelope" className="me-3" />
                    {config.email}
                  </p>
                )}
                {config.phone && config.show_phone !== "false" && (
                  <p>
                    <MDBIcon fas icon="phone" className="me-3" />
                    {config.phone}
                  </p>
                )}
                {config.whatsapp && config.show_whatsapp !== "false" && (
                  <p>
                    <a
                      href={`https://wa.me/${config.whatsapp.replace(/\D/g, "")}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-reset"
                    >
                      <MDBIcon fab icon="whatsapp" className="me-3" />
                      WhatsApp
                    </a>
                  </p>
                )}
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
        <div
          className="text-center p-4"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
        >
          {showIncidentBtn && (
            <div className="mb-2">
              <button
                className="btn btn-outline-danger btn-sm rounded-pill"
                onClick={this.handleOpenIncident}
              >
                <MDBIcon fas icon="life-ring" className="me-2" />
                Abrir incidencia
              </button>
              <IncidentCreateModal
                show={incidentOpen}
                onClose={this.handleCloseIncident}
                appCode={appCode}
              />
            </div>
          )}
          © {new Date().getFullYear()} {config.company_name}. Todos los derechos
          reservados.
        </div>
      </MDBFooter>
    );
  }
}

export default Footer;
